import { render, staticRenderFns } from "./vehicleHistorical.vue?vue&type=template&id=499d8178&"
import script from "./vehicleHistorical.vue?vue&type=script&lang=js&"
export * from "./vehicleHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports